import { defineNuxtPlugin } from '#imports'

const getLanguageFile = async (lang: string) => {
  const env = import.meta.env.VITE_APP_NODE_ENV
  switch (env) {
    case 'local':{
      const res = await import(`~/locales/explorer-plus.${lang}.json`)
      return res.default
    }
    case 'development': {
      const res = await fetch(
        `https://globalstatic.xangle.io/locales/explorer-plus.${lang}.dev.json`,
      )
      return await res.json()
    }
    case 'stage':
    case 'production':
    default: {
      const res = await fetch(
        `https://globalstatic.xangle.io/locales/explorer-plus.${lang}.json`,
      )
      return await res.json()
    }
  }
}

export default defineNuxtPlugin(async nuxtApp => {
  const enLocale = await getLanguageFile('en')
  const koLocale = await getLanguageFile('ko')

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  nuxtApp.$i18n.missingWarn = false
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  nuxtApp.$i18n.fallbackWarn = false
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  nuxtApp.$i18n.silentTranslationWarn = true
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  nuxtApp.$i18n.setLocaleMessage('en', enLocale)
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  nuxtApp.$i18n.setLocaleMessage('ko', koLocale)
})